<template>
<Panel header="Thêm nhóm">
  <div class="p-fluid p-formgrid p-grid">
        <div class="p-field p-col p-col-12 p-md-3 p-lg-3">
          <label>Tên nhóm</label>
          <InputText id="groupname" type="text" v-model="groupCreate.groupName" style="text-align: center"/>
        </div>
        <div class="p-field p-col p-col-12 p-md-3 p-lg-3">
          <label>Thêm nhóm</label>
          <Button label="Thêm" icon="pi pi-plus-circle" iconPos="left" @click="addGroup()" :disabled="!groupCreate.groupName"/>
        </div>
      </div>
</Panel>
  <Panel header="Thêm thành viên vào nhóm">
    <div class="p-fluid p-formgrid p-grid">
      <div class="p-field p-col p-col-12 p-md-4 p-lg-4">
        <label>Chọn nhóm</label>
        <Dropdown id="groupselect" v-model="idGroup" :options="listGroup" optionLabel="groupName" optionValue="id" :filter="true">
        </Dropdown>
      </div>
      <div class="p-field p-col p-col-12 p-md-4 p-lg-4">
        <label>Chọn thành viên</label>
        <Dropdown id="memberselect" v-model="idCustomer" :options="listCustomer" optionLabel="name" optionValue="idMember" :filter="true">
        </Dropdown>
      </div>
      <div class="p-field p-col p-col-12 p-md-4 p-lg-4">
        <label>Thêm thành viên vào nhóm</label>
        <Button label="Thêm" icon="pi pi-plus-circle" iconPos="left" @click="addMember()" :disabled="!(idGroup && idCustomer)" />
      </div>
    </div>
  </Panel>
  <Panel header="Xóa thành viên ra khỏi nhóm">
    <div class="p-fluid p-formgrid p-grid">
      <div class="p-field p-col p-col-12 p-md-4 p-lg-4">
        <label>Chọn nhóm</label>
        <Dropdown id="groupselectdelete" v-model="idGroupDelete" :options="listGroup" optionLabel="groupName" optionValue="id" @change="selectGroup" :filter="true">
        </Dropdown>
      </div>
      <div class="p-field p-col p-col-12 p-md-4 p-lg-4">
        <label>Chọn thành viên</label>
        <Dropdown id="memberselectdelete" v-model="idMemberDelete" :options="memberInGroup" optionLabel="zaloName" optionValue="id" :filter="true">
        </Dropdown>
      </div>
      <div class="p-field p-col p-col-12 p-md-4 p-lg-4">
        <label>Xóa thành viên ra khỏi nhóm</label>
        <Button label="Xóa" icon="pi pi-trash" iconPos="left" @click="deleteMember()" class="p-button-danger" :disabled="!(idGroupDelete && idMemberDelete)"/>
      </div>
    </div>
  </Panel>
</template>

<script lang="ts">

import { computed, ref } from 'vue'
import AuthRepository from '@/services/AuthRepository'
import { useToast } from "primevue/usetoast";
import { useRouter } from 'vue-router'
import {Register} from "../models/register";
import {useStore} from "vuex";
import TeamRepository from "../services/TeamRepository";
import {Team} from "@/models/team.models";
import {ListCustomer} from "@/models/listCustomer";
import ZaloRepository from "@/services/ZaloRepository";
import {EmployeeCreate} from "@/models/employeeCreate";
import zaloRepository from "@/services/ZaloRepository";
import {GroupCreate} from "@/models/groupCreate";
import teamRepository from "../services/TeamRepository";
import {Group} from "@/models/group";
import {MemberInGroupCreate} from "@/models/memberInGroupCreate";
import {MemberInGroup} from "@/models/memberInGroup";

export default {

  setup(){
    const router = useRouter();
    const register = ref({} as Register);
    const toast = useToast();
    const store = useStore();
    const error = ref(null);
    const groupCreate = ref({} as GroupCreate);
    const listGroup = ref([] as Group[]);
    const listCustomer = ref([] as ListCustomer[]);
    const idGroup = ref(0);
    const idCustomer = ref(0);
    const idGroupDelete = ref(0);
    const idMemberDelete = ref(0);
    const memberInGroup = ref([] as MemberInGroup[]);

    const loadListGroup = () => {
      teamRepository.listGroup()
          .then((response) => {
            listGroup.value = response.data;
          })
          .catch(err => {
            toast.add({
              severity: 'error',
              summary: 'Lỗi',
              detail: err.response.data,
              life: 2000
            });
          });
    }
    loadListGroup();

    const loadListMember = () => {
      ZaloRepository.getListCustomer()
          .then((response) => {
            listCustomer.value = response.data;
          })
          .catch(err => {
            toast.add({
              severity: 'error',
              summary: 'Lỗi',
              detail:'Lỗi khi tải danh sách khách hàng',
              life: 2000
            });
          });
    }

    loadListMember();

    const addGroup = () => {
      teamRepository.createGroup(groupCreate.value)
          .then((response) => {
            toast.add({
              severity: 'success',
              summary: 'Thành công',
              detail: 'Thêm nhóm mới thành công',
              life: 2000
            });
            loadListGroup();
          })
          .catch(err => {
            toast.add({
              severity: 'error',
              summary: 'Lỗi',
              detail: err.response.data,
              life: 2000
            });
          });
    }

    const addMember = () => {
      teamRepository.addMemberToGroup(idCustomer.value, idGroup.value)
          .then((response) => {
            toast.add({
              severity: 'success',
              summary: 'Thành công',
              detail: 'Thêm thành viên vào nhóm thành công',
              life: 2000
            });
            loadListGroup();
          })
          .catch(err => {
            toast.add({
              severity: 'error',
              summary: 'Lỗi',
              detail: err.response.data,
              life: 2000
            });
          });
    }

    const selectGroup = () => {
      console.log("################### selectGroup idGroupDelete: " + idGroupDelete.value);
      if(idGroupDelete.value > 0)
      teamRepository.getListMemberInGroup(idGroupDelete.value)
          .then((response) => {
            memberInGroup.value = response.data;
          })
          .catch(err => {
            toast.add({
              severity: 'error',
              summary: 'Lỗi',
              detail: err.response.data,
              life: 2000
            });
          });
    }

    const deleteMember = () => {
      teamRepository.deleteMember(idMemberDelete.value)
          .then((response) => {
            toast.add({
              severity: 'success',
              summary: 'Thành công',
              detail: 'Xóa thành viên ra khỏi nhóm thành công',
              life: 2000
            });
            selectGroup();
          })
          .catch(err => {
            toast.add({
              severity: 'error',
              summary: 'Lỗi',
              detail: err.response.data,
              life: 2000
            });
          });
    }

    return {
      register,
      error,
      addGroup,
      groupCreate,
      listCustomer,
      listGroup,
      idGroup,
      idCustomer,
      addMember,
      idGroupDelete,
      idMemberDelete,
      selectGroup,
      memberInGroup,
      deleteMember,
    }
  }
}

</script>
